/**
 * Select the most relevant user from a list of users based on the provided customer input.
 * It first checks for an exact phone number match, and if not found, it checks for a postalCode address match.
 *
 * @param customerInput The advanced customer input to match against.
 * @param users The list of users to search through.
 * @returns The most relevant user or null if no match is found.
 */
export const findBestMatchedUser = (customerInput, users) => {
    if (users.length === 1 && users[0])
        return users[0];
    if (users.length > 1) {
        const exactPhoneMatch = users.find((user) => user.phones?.some((phoneObj) => phoneObj.number === customerInput.phone));
        if (exactPhoneMatch) {
            return exactPhoneMatch;
        }
        if (customerInput.addresses && customerInput.addresses.length > 0) {
            const addressMatch = users.find((user) => user.addresses?.some((addr) => customerInput.addresses?.some((inputAddr) => addr.postalCode === inputAddr.postalCode)));
            if (addressMatch) {
                return addressMatch;
            }
        }
    }
    return null;
};
